import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3050';

function ForgotPasswordModal({ showNotification, setAuthView }) {
    const [step, setStep] = useState(1);
    const [username, setUsername] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSendOtp = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/forgot-password/otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message);
            showNotification(data.message, 'success');
            setStep(2);
        } catch (err) {
            showNotification(err.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/forgot-password/reset`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, otp, newPassword })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message);
            showNotification(data.message, 'success');
            setAuthView('login');
        } catch (err) {
            showNotification(err.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-box">
            <div className="login-header">
                <svg className="logo" viewBox="0 0 100 100"><path d="M 10,90 L 50,10 L 90,90 Z" fill="#fff" /><path d="M 30,90 L 50,50 L 70,90 Z" fill="#a78bfa" /></svg>
                <h2>Reset Password</h2>
                <p>{step === 1 ? 'Enter your username to receive an OTP' : 'Enter OTP and new password'}</p>
            </div>

            <form onSubmit={step === 1 ? handleSendOtp : handleResetPassword}>
                <div className="input-group">
                    <label>Username</label>
                    <input type="text" value={username} onChange={e => setUsername(e.target.value)} required disabled={isLoading || step === 2} />
                </div>

                {step === 2 && (
                    <>
                        <div className="input-group">
                            <label>Enter OTP from Email</label>
                            <input type="text" value={otp} onChange={e => setOtp(e.target.value)} required disabled={isLoading} />
                        </div>
                        <div className="input-group">
                            <label>New Password</label>
                            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required disabled={isLoading} />
                        </div>
                    </>
                )}

                <button type="submit" className="login-button" disabled={isLoading}>
                    {isLoading ? 'Processing...' : (step === 1 ? 'Send OTP' : 'Reset Password')}
                </button>
            </form>

            <div className="auth-switch">
                <p>Remembered? <button onClick={() => setAuthView('login')}>Sign In</button></p>
            </div>
        </div>
    );
}

export default ForgotPasswordModal;
